function updateScrollHeadingPosition() {
  const scrollHeading = document.querySelector('.scroll-heading')
  if (scrollHeading) {
    const leftOffset = Math.round(scrollHeading.getBoundingClientRect().left + window.scrollX)
    document.querySelectorAll('.cards').forEach((cards) => {
      cards.style.setProperty('--scroll-heading-left', `${leftOffset}px`)
    })
  }
}

// Initial ausführen
updateScrollHeadingPosition()

// Bei Fenstergrößenänderung aktualisieren
window.addEventListener('resize', updateScrollHeadingPosition)
